import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLowCarb = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	id: "lowcarb",
	"data-name": "lowcarb",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "-6 -6 36 36",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [
		title ? /* @__PURE__ */ _jsx("title", {
			id: titleId,
			children: title
		}) : null,
		/* @__PURE__ */ _jsx("circle", {
			className: "plan2plate-icon",
			cx: 12,
			cy: 12,
			r: 12.559595,
			id: "circle1"
		}),
		/* @__PURE__ */ _jsx("line", {
			className: "plan2plate-icon",
			x1: 21.138599,
			y1: 2.8613997,
			x2: 2.8613997,
			y2: 21.138599,
			id: "line1"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M 6.6274877,13.517791 A 11.711933,11.711933 0 0 0 4.3458111,14.70159 1.5047119,1.5047119 0 0 1 2.0089151,13.527674 v 0 C 1.9735126,11.641339 3.1260524,9.9192161 5.0060931,8.6716459 a 1.3108057,1.3108057 0 0 0 0.077358,0.3221909 l 1.3278406,4.1111162 a 1.5512494,1.5512494 0 0 0 0.216196,0.412838 z",
			id: "path1"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "m 21.870669,13.176859 v 0 a 1.5047119,1.5047119 0 0 1 -2.291202,1.260772 11.711933,11.711933 0 0 0 -2.32449,-1.097351 1.5512494,1.5512494 0 0 0 0.200555,-0.420658 l 1.150302,-4.1795685 a 1.3108057,1.3108057 0 0 0 0.06521,-0.3248661 c 1.919942,1.1707688 3.136287,2.8484326 3.199622,4.7616716 z",
			id: "path2"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "M 10.112659,14.20389 8.0179523,14.2432 A 1.6288119,1.6288119 0 0 1 6.6330739,13.523171 1.5512494,1.5512494 0 0 1 6.4168777,13.110334 L 5.0505497,8.9944543 A 1.3108057,1.3108057 0 0 1 4.9731918,8.6722634 1.659837,1.659837 0 0 1 6.5840837,6.8208585 l 1.7824552,-0.016996 a 1.5047119,1.5047119 0 0 0 -0.1670331,0.4529427 1.6520806,1.6520806 0 0 0 0.020816,0.8169433 l 1.3710334,4.6588505 0.3224844,1.107497 a 1.5047119,1.5047119 0 0 0 0.1988194,0.363794 z",
			id: "path3"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "m 18.665461,8.409807 a 1.3108057,1.3108057 0 0 1 -0.06521,0.3248654 l -1.19996,4.1640436 a 1.5512494,1.5512494 0 0 1 -0.200554,0.42066 1.6288119,1.6288119 0 0 1 -1.356886,0.771487 l -2.100087,0.04489 a 1.5047119,1.5047119 0 0 0 0.157301,-0.386934 l 0.280698,-1.118813 1.195259,-4.7070151 a 1.6520806,1.6520806 0 0 0 9.02e-4,-0.828322 1.5047119,1.5047119 0 0 0 -0.166946,-0.4192469 l 1.776251,-0.055279 a 1.659837,1.659837 0 0 1 1.679227,1.7896583 z",
			id: "path4"
		}),
		/* @__PURE__ */ _jsx("path", {
			className: "plan2plate-icon",
			d: "m 15.381401,7.9174093 -1.19526,4.7070157 -0.280701,1.118817 a 1.5047119,1.5047119 0 0 1 -0.157304,0.386933 1.6365681,1.6365681 0 0 1 -1.415661,0.854875 l -0.77866,0.01461 A 1.6365681,1.6365681 0 0 1 10.107074,14.19851 1.5047119,1.5047119 0 0 1 9.9353641,13.81775 L 9.612878,12.710254 8.2418455,8.051402 A 1.6520806,1.6520806 0 0 1 8.2154411,7.2290775 1.5047119,1.5047119 0 0 1 8.3665389,6.8038616 1.659837,1.659837 0 0 1 9.8037228,5.9266426 l 3.9371732,-0.073893 a 1.659837,1.659837 0 0 1 1.469088,0.8226754 1.5047119,1.5047119 0 0 1 0.183912,0.4463558 1.6520806,1.6520806 0 0 1 -0.01249,0.7956267 z",
			id: "path5"
		})
	]
});
const ForwardRef = forwardRef(SvgLowCarb);
export default ForwardRef;
